module.exports = __webpack_public_path__ + "static/media/background.c2203c0b.jpg";